var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReligion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.391,
    height: 20.455,
    viewBox: "0 0 11.391 20.455",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0426\\u0435\\u0440\\u043A\\u0432\\u0438",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_585",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 585",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_584",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 584"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1656",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1656",
    d: "M124.651,10.687,119.907,4.88V3.365h.734a.776.776,0,0,0,0-1.553h-.734V.776a.777.777,0,0,0-1.553,0V1.812h-.734a.776.776,0,1,0,0,1.553h.734V4.88l-4.744,5.807a.777.777,0,0,0-.175.491v8.5a.777.777,0,0,0,.777.776h1.658V17.185a3.261,3.261,0,0,1,6.522,0v3.271h1.658a.777.777,0,0,0,.776-.776v-8.5A.777.777,0,0,0,124.651,10.687Z",
    transform: "translate(-113.435 0)",
    fill: "current"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_587",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 587",
    transform: "translate(3.159 14.648)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_586",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 586"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1657",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1657",
    d: "M195.046,366.648a2.539,2.539,0,0,0-2.536,2.537v3.271h.776V369.3a1.76,1.76,0,0,1,3.52,0v3.154h.777v-3.271A2.539,2.539,0,0,0,195.046,366.648Z",
    transform: "translate(-192.51 -366.648)",
    fill: "current"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReligion);
export default __webpack_public_path__ + "static/media/Religion.9efac08bd36ae85da7b29c0238025e54.svg";
export { ForwardRef as ReactComponent };